import { api } from "./client";
import type { Source } from "../types";

export async function getSources(
  projectId: string,
  opts?: { selected?: boolean },
): Promise<Source[]> {
  const params =
    opts?.selected === undefined ? undefined : { selected: String(opts.selected) };
  const { data } = await api.get<Source[]>(`/projects/${projectId}/sources`, {
    params,
  });
  return data;
}

export async function patchSource(
  sourceId: string,
  body: { selected: boolean },
): Promise<Source> {
  const { data } = await api.patch<Source>(`/sources/${sourceId}`, body);
  return data;
}

export async function selectAll(
  projectId: string,
  body: { selected: boolean },
): Promise<{ updated: number }> {
  const { data } = await api.post<{ updated: number }>(
    `/projects/${projectId}/sources/select-all`,
    body,
  );
  return data;
}

export async function validateAccess(projectId: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>(
    `/projects/${projectId}/sources/validate-access`,
    {},
  );
  return data;
}
